import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { LoadingIndicator } from '@adflow/frontend/ui-graphics';
import { useAuthSafe, useRedirectToLogin } from '@adflow/frontend/util-auth';

export function RequireLogin({ children }: { children: ReactNode }) {
	const { status } = useAuthSafe();
	const redirectToLogin = useRedirectToLogin();

	useEffect(() => {
		if (status === 'logged-out') {
			redirectToLogin();
		}
	}, [redirectToLogin, status]);

	return status === 'logged-in' ? children : <LoadingIndicator />;
}
